import { x } from "@xstyled/styled-components";
import { useMemo } from "react";

import { useJobEditFormikContext } from "../../useHandlers";

import { OfficeDays } from "./OfficeDays";
import { StructuredOfficeLocation } from "./StructuredOfficeLocation";
import { RemoteField } from "./RemoteField";
import { OfficeDescription } from "./OfficeDescription";
import { OfficeLocation } from "./OfficeLocation";

import { isRemote } from ".";

import {
  locationToLocationOption,
  CA_LOCATIONS,
  EU_LOCATIONS,
  UK_LOCATIONS,
  US_LOCATIONS,
} from "@hire/util/locations";
import { Location } from "@hire/schema";

export const OfficeField = () => {
  const form = useJobEditFormikContext();
  const options = useMemo(() => {
    return [...CA_LOCATIONS, ...EU_LOCATIONS, ...UK_LOCATIONS, ...US_LOCATIONS]
      .filter(location => !isRemote(location))
      .map(locationToLocationOption)
      .filter(
        (option): option is { label: string; value: Location } => !!option
      )
      .map(option => {
        return {
          value: option.value,
          label: option.label.replace("(", "").replace(")", ""),
        };
      });
  }, []);

  const value = useMemo(
    () =>
      options.filter(
        option =>
          option && form.values.officeLocationPreferences.includes(option.value)
      ),
    [form.values.officeLocationPreferences, options]
  );

  const remoteLocations = useMemo(
    () =>
      form.values.remoteLocationPreferences
        .map(locationToLocationOption)
        .filter(
          (option): option is { label: string; value: string } => !!option
        ),
    [form.values.remoteLocationPreferences]
  );

  const matchingLocations = [...value, ...remoteLocations]
    .map(({ label }) => label)
    .join(", ");

  return (
    <x.div display="flex" flexDirection="column" gap="md">
      {form.values.hasOfficeLocationPreferences && (
        <OfficeLocation options={options} value={value} />
      )}
      {form.values.hasOfficeLocationPreferences && (
        <StructuredOfficeLocation matchingLocations={matchingLocations} />
      )}
      {form.values.hasRemoteLocationPreferences && <RemoteField />}
      {form.values.hasOfficeLocationPreferences && <OfficeDescription />}
      {form.values.hasOfficeLocationPreferences && <OfficeDays />}
    </x.div>
  );
};
